import React, { useContext, useEffect, useState } from "react";
import "./Category.css";
import Common_Category_Card from "../../common_components/common_category_card/Common_Category_Card";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";
import { luxuryCategory } from "../../../utils/luxuryapis/Home/Homeapi";
const Category = () => {
  const { IMG_URL } = useContext(Context);
  const [categories, setCategories] = useState();

  const getAllLuxuryCategory = async () => {
    const res = await luxuryCategory();
    if (res?.success) {
      setCategories(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllLuxuryCategory();
  }, []);

  const navigate = useNavigate();

  return (
    <section className="Category">
      <div className="custom_container">
        <div className="content_div">
          <div className="row">
            {categories?.map((item) => {
              return (
                <div className="col-xl-3 col-md-4 col-6">
                  <Common_Category_Card
                    imgSrc={IMG_URL + item?.image}
                    title={item?.name}
                    onClick={() => {
                      navigate(`/luxury/products?category_id=${item?.id}&name=${item?.name}`);
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Category;
